import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/switch_home.gif';
import _imports_1 from '../assets/home_cont1.png';
import _imports_2 from '../assets/home_cont2.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3c567cee"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "home"
};
var _hoisted_2 = {
  class: "banner"
};
var _hoisted_3 = {
  class: "swiper-wrapper"
};
var _hoisted_4 = {
  class: "swiperitem",
  style: {
    "width": "100%",
    "height": "100%"
  }
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "bannertext"
};
var _hoisted_7 = {
  class: "btnwrap"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"title_line\" data-v-3c567cee>教育机构一站式服务平台</div><div class=\"cont1\" data-v-3c567cee><img src=\"" + _imports_1 + "\" alt=\"\" data-v-3c567cee></div><div class=\"cont2\" data-v-3c567cee><div class=\"title_lb\" data-v-3c567cee>合作流程</div><img src=\"" + _imports_2 + "\" alt=\"\" data-v-3c567cee></div>", 3);

var _hoisted_12 = {
  class: "cont3"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title_lb"
  }, "服务领域", -1);
});

var _hoisted_14 = {
  class: "banner2"
};
var _hoisted_15 = {
  class: "swiper-wrapper"
};
var _hoisted_16 = {
  class: "swiperitem"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  class: "itemcont"
};
var _hoisted_19 = ["src"];
var _hoisted_20 = {
  class: "info"
};
var _hoisted_21 = {
  class: "tit"
};
var _hoisted_22 = {
  class: "tip"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bannerlist, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: index
    }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      src: item.src,
      style: {
        "width": "100%",
        "height": "100%"
      },
      alt: ""
    }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(item.text), 1)])]);
  }), 128))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "joinbtn",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.topath && $options.topath.apply($options, arguments);
    })
  }, "申请入住"), _hoisted_8])]), _hoisted_9, _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fuwu, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: index
    }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
      class: "bg",
      src: item.src,
      style: {
        "width": "100%",
        "height": "100%"
      },
      alt: ""
    }, null, 8, _hoisted_17), _createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
      src: item.icon,
      alt: ""
    }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", _hoisted_21, _toDisplayString(item.tit), 1), _createElementVNode("p", _hoisted_22, _toDisplayString(item.tip), 1)])])]);
  }), 128))])])])]);
}